<template>
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <h1 class="text-right"><i class="fa-duotone fa-box-circle-check fa-fw"></i> Intake</h1>
                </b-col>
            </b-row>

            <b-modal id="modal-1" title="Manually Receive Kit" header-bg-variant="secondary">
                <p class="my-4">Hello from modal!</p>
            </b-modal>

            <b-row>
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">
            <b-row>
                <b-col>

                    <dashboard-side-data-widget label="Expected Packages " :data="dashboardData.totalPackagesExpected"
                                                icon="fa-light fa-dolly-flatbed"></dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Packages Outstanding" :data="dashboardData.totalPackagesOutstanding" clickable
                                                to="/intake/outstanding" icon="fa-light fa-pallet-boxes"
                                                :color-data="dashboardData.totalPackagesOutstanding > 0 ? 'danger' : ''"
                                                :color-accent="dashboardData.totalPackagesOutstanding > 0 ? 'danger' : ''"></dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Total Packages Received" :data="dashboardData.totalPackagesReceived"
                                                icon="fa-light fa-boxes"></dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Orders Received" :data="dashboardData.totalKitsReceived" clickable
                                                to="/intake/received"
                                                icon="fa-light fa-box-circle-check"></dashboard-side-data-widget>
                </b-col>
            </b-row>
        </b-col>

    </b-row>
</template>

<script>
    import {
        BROADCAST_CONNECTED,
    } from '../../store/actions';
    import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
    import {assign} from 'lodash';

    export default {
        name: 'intake-index',
        title: 'Intake',
        components: {DashboardSideDataWidget},
        data() {
            return {
                dashboardData: {
                    totalPackagesExpected: null,
                    totalPackagesReceived: null,
                    totalPackagesOutstanding: null,
                    totalKitsReceived: null,
                },
            };
        },
        created() {

        },
        mounted() {
            this.getDashboardData();

            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }

            // this.$barcodeScanner.init((rawBarcode) => {
            //     this.$barcodeScanner.parseBarcode(rawBarcode, barcode => {
            //         this.$router.push({path: '/intake/view/' + encodeURIComponent(barcode)});
            //     });
            // });
        },
        beforeDestroy() {
            console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.Intake channel from Intake/index.vue.');
            this.$echo.leaveChannel('App.Intake');
            // this.$barcodeScanner.destroy();
        },
        methods: {
            joinBroadcastChannel: function () {
                console.info(String.fromCodePoint(0x1F91D) + ' Joining App.Intake channel from Intake/index.vue.');
                this.$echo.channel('App.Intake')
                    .listen('PackageWasCreated', (e) => {
                    this.$bvToast.toast('Package weight saved.');
                })
                    .listen('KitWasReceived', (e) => {
                        this.$bvToast.toast('Kit received.');
                })
                .listen('BroadcastDashboardUpdate', (e) => {
                    this.dashboardData = assign(this.dashboardData, e.payload);
                });
            },
            getDashboardData() {
                this.$http.get('/dashboards/intake')
                    .then(response => {
                        this.dashboardData = assign(this.dashboardData, response.data.data);

                    });
            },
        }
    };

</script>

<style scoped>

</style>
